<template>
  <v-dialog width="620" v-model="dialog" persistent scrollable>
    <v-card>
      <v-card-title class="blue darken-4 white--text">
        <v-toolbar-title>CẬP NHẬP THÔNG TIN HỆ ĐÀO TẠO</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn dark icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text class="px-6 pt-6 pb-0">
        <v-form v-bind="this.$attrs" ref="form">
          <v-text-field
            label="Tên"
            v-model="name"
            outlined
            :rules="[$rules.required]"
            class="required"
            hide-details
          ></v-text-field>
          <v-text-field
            label="Tên viết tắt"
            required
            v-model="acronym"
            outlined
            :rules="[$rules.required]"
            class="pt-6 required"
          ></v-text-field>
          <v-select
            label="Phân loại"
            :items="types"
            item-text="name"
            item-value="id"
            v-model="type"
            outlined
            :rules="[$rules.selectRequired]"
            class="required"
          ></v-select>
          <v-select
            label="Trạng thái"
            :items="statusOptions"
            item-text="label"
            item-value="value"
            v-model="status"
            class="required"
            outlined
            required
            :rules="[$rules.status]"
          ></v-select>
          <v-textarea label="Ghi chú" class="pb-6" v-model="note" outlined hide-details></v-textarea>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="pa-6">
        <v-btn color="blue darken-4" outlined @click="close">Hủy </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-4" dark @click="submit">Xác nhận</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
export default {
  props: {
    state: Boolean,
    profile: Object,
    types: Array
  },
  watch: {
    state(state) {
      this.dialog = state
      if (!state) this.loading = false
    },
    profile: {
      immediate: true,
      handler(newProfile) {
        if (newProfile) {
          this.setFormValues(newProfile)
        }
      }
    }
  },
  computed: {
    ...mapGetters('auth', ['user'])
  },
  data() {
    return {
      dialog: false,
      loading: false,
      name: '',
      acronym: '',
      type: '',
      status: '',
      note: '',
      statusOptions: [
        {label: 'Đang hoạt động', value: 'active'},
        {label: 'Đã bị khóa', value: 'inActive'},
        {label: 'Đã bị xóa', value: 'removed'}
      ]
    }
  },
  methods: {
    ...mapActions('product', ['updateProduct']),

    close() {
      this.$emit('closeDialog')
    },

    async submit() {
      if (this.$refs.form.validate()) {
        this.$loading.active = true
        let data = {
          name: this.name,
          acronym: this.acronym,
          note: this.note,
          status: this.stautus,
          productType: this.type
        }
        const updateSale = await this.updateProduct({id: this.profile.id, ...data})
        if (updateSale) {
          this.$emit('refresh')
          this.close()
        }
      }
    },
    setFormValues(profile) {
      this.name = profile.name || ''
      this.acronym = profile.acronym || ''
      this.type = profile.productType
      this.note = profile.note || ''
      this.status = profile.status || ''
    }
  }
}
</script>

<style>
.v-text-field.v-text-field--enclosed .v-text-field__details {
  margin-bottom: 2px !important;
}
</style>
